import {
    warningColor,
    primaryColor,
    dangerColor,
    successColor,
    infoColor,
    roseColor,
    grayColor,
    defaultFont,
} from "assets/jss/material-kit-pro-react.js";
import { whiteColor } from "../../material-kit-pro-react";

const tableStyle = {
    warning: {
        color: warningColor[0],
    },
    primary: {
        color: primaryColor[0],
    },
    danger: {
        color: dangerColor[0],
    },
    success: {
        color: successColor[0],
    },
    info: {
        color: infoColor[0],
    },
    rose: {
        color: roseColor[0],
    },
    gray: {
        color: grayColor[0],
    },
    right: {
        textAlign: "right",
    },
    table: {
        padding: "10px",
        marginBottom: "0",
        width: "100%",
        maxWidth: "100%",
        backgroundColor: "transparent",
        borderSpacing: "0",
        borderCollapse: "collapse",
        overflow: "auto",
        "& > tbody > tr, & > thead > tr": {
            height: "auto",
        },
        //"& th":
        
        //    { textAlign: "left", background: "#eee", position: "sticky", top: "0px" }
        

    },
    tableShoppingHead: {
        fontSize: "0.75em !important",
        textTransform: "uppercase !important",
    },
    tableCell: {
        ...defaultFont,
        lineHeight: "1.5em",
        padding: "12px 8px!important",
        verticalAlign: "middle",
        fontSize: "0.999rem",
        borderBottom: "none",
        borderTop: "2px solid " + grayColor[6],
        position: "relative",
        color: grayColor[1],
        borderWidth: 0, borderWidth: 1, borderColor: grayColor[6], borderStyle: 'solid',
        width: "auto",
    },
    tableHeadCell: {
        fontSize: "1.17rem",
        borderBottomWidth: "2px",
        fontWeight: "400",
        color: whiteColor,
        borderTopWidth: "0 !important",
        backgroundColor: infoColor[0],
        //width: "14.2%",
        //height: "100%"

    },
    tableCellTotal: {
        fontWeight: "500",
        fontSize: "1.0625rem",
        paddingTop: "20px",
        textAlign: "right",
    },
    tableCellAmount: {
        fontSize: "26px",
        fontWeight: "300",
        marginTop: "5px",
        textAlign: "right",
    },
    tableResponsive: {
        minHeight: "0.1%",
        overflowX: "auto",
        /*        padding: "2px"*/
    },
    tableStripedRow: {
        backgroundColor: grayColor[16],
    },
    tableRowHover: {
        "&:hover": {
            backgroundColor: grayColor[23],
        },
    },
    warningRow: {
        backgroundColor: warningColor[4],
        "&:hover": {
            backgroundColor: warningColor[5],
        },
    },
    dangerRow: {
        backgroundColor: dangerColor[4],
        "&:hover": {
            backgroundColor: dangerColor[5],
        },
    },
    successRow: {
        backgroundColor: successColor[4],
        "&:hover": {
            backgroundColor: successColor[5],
        },
    },
    infoRow: {
        backgroundColor: infoColor[4],
        "&:hover": {
            backgroundColor: infoColor[5],
        },
    },
    tableRightBorder: { borderWidth: 0, borderWidth: 1, borderColor: 'red', borderStyle: 'solid' } // or borderTop: '1px solid red'


  


};

export default tableStyle;
